import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { LeadersList } from 'containers/pages'
import { meta } from 'helpers/decorators'

@meta({
  title: 'Awards leaders',
  intlKey: 'pageTitle.award_leaders',
  dynamicProp: 'organizations.detail.name',
  dynamicPropId: 'organizations.detail.globalId'
})
class OrganizationAwardLeaders extends Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired
  }
  render() {
    const { organizations } = this.props

    return (
      <LeadersList
        {...this.props}
        decoFilter="organizationLeaders"
        organizationHierarchyId={get(
          organizations,
          'detail.organizationHierarchyLevel.id'
        )}
      />
    )
  }
}

export default OrganizationAwardLeaders
